import { createI18n } from 'vue-i18n';

import validationMessages from '@/dictionary'

const i18n = createI18n({
    locale: 'es',
    messages: validationMessages
});

export default i18n;